import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
// @ts-nocheck
import InputMask from "react-input-mask";
import { Input } from "ui";

import { InventoryManagerFormAtomProps } from "../InventoryManagerForm.types";

const PhoneField = ({ control }: InventoryManagerFormAtomProps) => {
  const { t } = useTranslation();
  return (
    <Controller
      control={control}
      name="phoneNumber"
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <InputMask
          mask="+999 99 99999999"
          value={value}
          onChange={onChange}
          alwaysShowMask={false}
          maskChar=""
        >
          {(inputProps) => (
            <Input
              {...inputProps}
              type="tel"
              label={t("Phone number")}
              placeholder={t("Enter Phone Number")}
              errorMessage={error?.message}
              data-testid="inventory-manager--phoneNumber"
            />
          )}
        </InputMask>
      )}
    />
  );
};

export default PhoneField;
